import React, {useEffect, useState} from "react";
import {
  Box,
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import {
  IconAlertTriangle, IconDeviceFloppy, IconTrash,
} from "@tabler/icons-react";
import {ProjectForm} from "../../project-creation/components/ProjectForm";
import Typography from "@mui/material/Typography";
import {red} from "@mui/material/colors";

export const ProjectUpdateForm = ({
                                    project,
                                    setProject,
                                    languages,
                                    organizations,
                                    asriProjects,
                                    fetchData,
                                    users,
                                    loading,
                                    onDelete
                                  }) => {

  const [addMemberDialog, setAddMemberDialog] = useState(false);

  const updateProject = (key, value) => {
    setProject(prev => ({...prev, [key]: value}))
  }

  return (
    <>
      <AddMemberDialog
        open={addMemberDialog}
        handleClose={() => setAddMemberDialog(false)}
        users={users}
        onSuccess={(newUser) => {
          if (newUser) {
            const team = project?.team || [];
            const uniqueMembers = new Set([...team, newUser]);
            updateProject("team", [...uniqueMembers]);
          }
          setAddMemberDialog(false);
        }}
      />
      <Box sx={{pt: {xs: 2, md: 3}, px: {xs: 2, md: 4}}}>
        <Typography fontWeight={600} fontSize={{xs: "1.1rem", md: "1.25rem"}}>Project Details</Typography>
        <Typography variant={"body2"} color={"text.secondary"} sx={{mt: 0.5}}>
          Update the core configuration for this project.
        </Typography>
      </Box>
      <Box sx={{py: 1}}>
        <ProjectForm setProject={setProject} project={project} languages={languages} organizations={organizations}
                     asriProjects={asriProjects} fetchData={fetchData}/>
      </Box>

      <Box sx={{px: {xs: 2, md: 4}, pb: {xs: 2, md: 3}}}>
        <Divider sx={{mb: {xs: 2, md: 3}}}/>
        <Stack
          direction={{xs: "column", sm: "row"}}
          gap={1.5}
          alignItems={{xs: "flex-start", sm: "flex-start"}}
          sx={{
            borderRadius: 3,
            p: 2,
            border: 1,
            borderColor: red[100],
            bgcolor: red[50]
          }}
        >
          <Box sx={{color: red[500], display: "flex", pt: "2px"}}>
            <IconAlertTriangle size={20}/>
          </Box>
          <Box sx={{flex: 1}}>
            <Typography fontWeight={600} color={red[700]} fontSize={"0.9rem"}>Danger Zone</Typography>
            <Typography variant={"body2"} color={red[600]} sx={{mb: 1.5, maxWidth: "sm"}}>
              Deleting this project permanently removes it and all of its versions. This action cannot be undone.
            </Typography>
            <Button
              type={"button"} variant={"outlined"} color={"error"}
              onClick={onDelete} disabled={loading}
              sx={{
                borderRadius: 2, minHeight: {xs: 40, md: "auto"}, width: {xs: "100%", sm: "auto"},
                borderColor: red[300], "&:hover": {borderColor: red[500], bgcolor: red[100]}
              }}
              startIcon={<IconTrash size={16}/>}
            >
              Delete Project
            </Button>
          </Box>
        </Stack>
      </Box>

      <Stack
        direction={"row"}
        justifyContent={"flex-end"}
        gap={{xs: 1, sm: 2}}
        sx={{
          position: {xs: "sticky", md: "static"},
          bottom: 0,
          zIndex: 2,
          px: {xs: 2, md: 4},
          py: {xs: 1.5, md: 2},
          bgcolor: "background.paper",
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        <Button type={"submit"} variant={"primary"} disabled={loading}
                sx={{minHeight: {xs: 44, md: "auto"}, flex: {xs: 1, sm: "initial"}, px: {xs: 3, md: 2.5}}}
                startIcon={<IconDeviceFloppy size={18}/>}>
          Save Changes
        </Button>
      </Stack>
    </>
  )
}

const AddMemberDialog = ({open, handleClose, users, onSuccess}) => {
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if (!open) {
      setSelectedUser(null);
    }
  }, [open])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{sx: {borderRadius: 3}}}
    >
      <DialogTitle id="alert-dialog-title">
        {"Add Member"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Select
            labelId="demo-multiple-chip-label"
            id="demo-multiple-chip"
            sx={{flex: 1, m: {xs: 0, sm: 1}, mt: {xs: 1, sm: 1}, width: {xs: "100%", sm: "auto"}, minWidth: {sm: "300px"}}}
            value={selectedUser || ""}
            onChange={e => setSelectedUser(e.target.value)}
          >
            {users.map((name) => (
              <MenuItem
                key={name}
                value={name}
              >
                {name}
              </MenuItem>
            ))}
          </Select>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="ghost" sx={{mr: "auto"}} onClick={handleClose}>Cancel</Button>
        <Button variant="modal" onClick={() => onSuccess(selectedUser)} disabled={selectedUser === null}
                autoFocus>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  )
}
